'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;
// import { FormControl } from 'react-bootstrap';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _voucher = require('redux/modules/voucher');

var vouchersAction = _interopRequireWildcard(_voucher);

var _VoucherCard = require('./VoucherCard');

var _VoucherCard2 = _interopRequireDefault(_VoucherCard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { renderTime } from '../../helpers/lib';

// import avatar from './avatar.jpg';

var Voucher = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    vouchers: state.voucher.vouchers
  };
}, (0, _extends3.default)({}, vouchersAction)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Voucher, _Component);

  function Voucher() {
    (0, _classCallCheck3.default)(this, Voucher);
    return (0, _possibleConstructorReturn3.default)(this, (Voucher.__proto__ || (0, _getPrototypeOf2.default)(Voucher)).apply(this, arguments));
  }

  (0, _createClass3.default)(Voucher, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.getByUser();
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Voucher.scss');
      var vouchers = this.props.vouchers ? this.props.vouchers.reverse() : [];
      return _react2.default.createElement(
        'div',
        { className: styles.voucher },
        _react2.default.createElement(
          'div',
          { className: styles.header },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            '\u0110i\u1EC3m th\u01B0\u1EDFng & Voucher'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.body },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            vouchers ? vouchers.map(function (item, key) {
              return _react2.default.createElement(
                'div',
                { className: 'col-xs-6 col-md-4', key: key },
                _react2.default.createElement(_VoucherCard2.default, { item: item })
              );
            }) : _react2.default.createElement(
              'div',
              null,
              'Kh\xF4ng t\xECm th\u1EA5y vouchers kh\u1EA3 d\u1EE5ng!'
            )
          )
        )
      );
    }
  }]);
  return Voucher;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  vouchers: _react.PropTypes.array,
  getByUser: _react.PropTypes.func
}, _temp)) || _class);
exports.default = Voucher;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountManagement/Voucher.js
// module id = 1504
// module chunks = 0